
export const to4Digit = number =>
  (new Array(4).join('0') + number).substr(-4)

export const toCurrency = number => (`R$ ${number.toFixed(2)}`).toString().replace('.', ',')

export const toFullCurrency = (value) => {
  let num = value
  if (!num && num !== 0) {
    return null
  }
  if (typeof num === 'number') {
    num = parseFloat(num).toFixed(2)
  }
  if (typeof num !== 'string') {
    num = String(num)
  }
  const newValue = Number(num.replace(/[^0-9]/g, '') / 100).toFixed(2).split('.')
  newValue[0] = newValue[0].split(/(?=(?:...)*$)/).join('.')
  return `R$ ${newValue.join(',')}`
}

/** Abbreviates thousands with a "k" suffix (e.g. 25000 → "R$ 25k", 1900 → "R$ 1.9k"). */
export const formatCompactThousands = (value) => {
  const num = Number(value)
  if (Number.isNaN(num)) return 'R$ 0'

  const abs = Math.abs(num)
  if (abs < 1000) {
    return `R$ ${Math.round(num)}`
  }

  const inThousands = num / 1000
  const rounded = Math.round(inThousands * 10) / 10
  const formatted = Number.isInteger(rounded)
    ? String(rounded)
    : String(rounded).replace(/\.0$/, '')

  return `R$ ${formatted}k`
}

export const integerTransform = (value) => {
  let num = value
  if (!num) {
    return null
  }
  if (typeof num !== 'string') {
    num = String(num)
  }
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
export const newIntegerTransform = (value) => {
  let num = value
  if (!num) {
    return null
  }
  if (typeof num !== 'string') {
    num = String(num)
  }

  return num.toString().replace(/\./g, '')
}
export const floatTransform = (value) => {
  let num = value
  if (!num) {
    return null
  }
  if (typeof num !== 'string') {
    num = String(num)
  }
  const newValue = Number(num.replace(/(?!^-)[^0-9]/g, '') / 100).toFixed(2).split('.')
  if (newValue[0].charAt(0) === '-') {
    newValue[0] = newValue[0].replace('-', '')
    newValue[0] = newValue[0].split(/(?=(?:...)*$)/).join('.')
    return `-${newValue.join(',')}`
  }
  newValue[0] = newValue[0].split(/(?=(?:...)*$)/).join('.')
  return `${newValue.join(',')}`
}


export const toPhoneFormat = (phone) => {
  const localPhone = String(phone).replace(/\W/g, '')
  if (localPhone.length === 10) {
    return localPhone.replace(/(\d\d)(\d\d\d\d)(\d\d\d\d)/, '($1) $2-$3')
  }
  return localPhone.replace(/(\d\d)(\d\d\d\d\d)(\d\d\d\d)/, '($1) $2-$3')
}

export const tonFormatter = (valueInKg) => {
  const numberValue = parseFloat(valueInKg)
  return (numberValue / 1000).toFixed(2)
}

export const thousandFormatter = (value) => {
  if (!value) {
    return 0
  }
  const hasDecimal = String(value).indexOf('.') > -1
  let num = String(value).replace(/[^0-9-\\]+/g, '')

  if (typeof num !== 'string') {
    num = String(num)
  }

  let finalNumber = (Number(num.replace(/[^0-9-\\]+/g, '')).toFixed(2))
  if (hasDecimal) {
    finalNumber = Number(num.replace(/[^0-9-\\]+/g, ''))
  }

  return finalNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const formatProposalValue = (value, negotiationByMargin) => {
  if (value === undefined || value === null) return '-'

  if (negotiationByMargin) {
    return `${value}%`
  }

  return toFullCurrency(value)
}
